import { useAuth } from '../contexts/AuthContext';

export function useSubscription() {
  const { user } = useAuth();

  const hasActiveSubscription = (): boolean => {
    if (!user) return false;
    return user.has_access === true;
  };

  return {
    hasActiveSubscription
  };
}